export default "__VITE_ASSET__rA4ig1WJ__"